import React from "react";
import styled, { css } from "styled-components";

import { hsl } from "../../utils/color";

const StyledLabel = styled.label<
  Pick<LabelProps, "layout"> & {
    isClickable?: boolean;
    disableGrow?: boolean;
  }
>`
  display: flex;
  flex-direction: ${(props) => props.layout ?? "column"};
  gap: 1ch;

  ${(props) => props.isClickable && "cursor: pointer;"}

  // grow whatever is in props.children
  // ... except select, which does weird things when flex. ugh
  // or checkbox. Or textarea. This is starting to be a mess lol
  ${({ disableGrow }) => {
    return (
      !disableGrow &&
      css`
        &
          > *:not(:first-child):not(select):not(input[type="checkbox"]):not(
            textarea
          ) {
          flex: 1;
        }
      `
    );
  }}


  // fix checkbox in safari
  * > input[type="checkbox"] {
    flex-shrink: 0;
  }
`;

export const LabelText = styled.span<{ layout?: string }>`
  display: inline-block;
  font-size: 1.2rem;
  color: ${(props) => hsl(props.theme.colors?.secondary.textColor)};

  /* text-transform: uppercase; */
  color: #666;
  text-shadow: 1px 1px 1px #fff;

  place-self: ${(props) => (props.layout === "row" ? "center" : "flex-start")};
`;

export interface LabelProps extends React.HTMLAttributes<HTMLLabelElement> {
  label: string | React.ReactNode;
  layout?: "row" | "column";
  disableGrow?: boolean;
}

const LabelComponent = ({
  layout,
  label,
  disableGrow,
  children,
  ...labelProps
}: LabelProps) => {
  return (
    <StyledLabel
      layout={layout}
      isClickable
      disableGrow={disableGrow}
      {...labelProps}
    >
      <LabelText layout={layout}>{label}</LabelText>
      {children}
    </StyledLabel>
  );
};
export const Label = styled(LabelComponent)``;

/**
 * The standard `<LabelComponent />` clicks on the first child form field when
 * clicked. If this is not desirable, but we want something that looks like a
 * `<LabelComponent />` we can use this.
 */
export const LabelLike = (props: LabelProps) => {
  return (
    <StyledLabel layout={props.layout} as="div" disableGrow={props.disableGrow}>
      <LabelText layout={props.layout}>{props.label}</LabelText>
      {props.children}
    </StyledLabel>
  );
};
export default Label;
